import { render } from "./Laporan6A.vue?vue&type=template&id=e5ecda50"
import script from "./Laporan6A.vue?vue&type=script&lang=js"
export * from "./Laporan6A.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__